import { StampingPreviewCanvas } from "../components/StampingPreviewCanvas";
import { StampingPreview } from "../components/StampingPreview";

export default class SimpleProductPage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }

  init() {
    if (this.dom.querySelector(".stamping-canvas-wrapper")) {
      this.stampingPreviewCanvas = this.initStampingPreviewCanvas();
      this.stampingPreview = this.initStampingPreview();

      this.stampingPreviewCanvas.attachStampingPreview(this.stampingPreview);
    }
  }

  initStampingPreviewCanvas() {
    const canvasContainer = this.dom.querySelector(".stamping-canvas-wrapper");
    let canvas = new StampingPreviewCanvas(canvasContainer);
    canvas.init();
    return canvas;
  }

  initStampingPreview() {
    let preview = new StampingPreview(
      this.stampingPreviewCanvas,
      this.stampingPreviewCanvas.getSettings()
    );
    preview.init();
    return preview;
  }

  resize() {
    clearTimeout(this.resizeTO);
    if(this.stampingPreview){
      this.resizeTO = setTimeout(() => {
        this.stampingPreview.updateSettings(
          this.stampingPreviewCanvas.getSettings()
        );
      }, 100);
    }
  }
}
